<script setup>
import { onMounted } from 'vue';
import { verifyPasswordToken } from 'v3/api/auth';
import Spinner from 'shared/components/Spinner.vue';
import { DEFAULT_REDIRECT_URL } from 'dashboard/constants/globals';

const props = defineProps({
  confirmationToken: {
    type: String,
    default: '',
  },
});

const confirmToken = async () => {
  try {
    await verifyPasswordToken({
      confirmationToken: props.confirmationToken,
    });
    window.location = DEFAULT_REDIRECT_URL;
  } catch (error) {
    window.location = DEFAULT_REDIRECT_URL;
  }
};

onMounted(() => {
  confirmToken();
});
</script>

<template>
  <div
    class="flex flex-col items-center justify-center min-h-screen h-full bg-surface-container-lowest w-full space-y-4"
  >
    <Spinner color-scheme="primary" size="large" />
    <div
      class="text-on-surface-variant font-label-md text-label-md animate-pulse"
    >
      Confirming your email address...
    </div>
  </div>
</template>
